module.exports = __webpack_public_path__ + "imgs/BailProject.d2e280b46ec7134dfdd23a84875c8b51.png";